export default "__VITE_ASSET__oUzab8wt__"